import { render, staticRenderFns } from "./DoctorOrderComponent.vue?vue&type=template&id=ece8507a&scoped=true&"
import script from "./DoctorOrderComponent.vue?vue&type=script&lang=js&"
export * from "./DoctorOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./DoctorOrderComponent.vue?vue&type=style&index=0&id=ece8507a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece8507a",
  null
  
)

export default component.exports